import { render, staticRenderFns } from "./equipment.vue?vue&type=template&id=2388ff95&scoped=true"
import script from "./equipment.vue?vue&type=script&lang=js"
export * from "./equipment.vue?vue&type=script&lang=js"
import style0 from "./equipment.vue?vue&type=style&index=0&id=2388ff95&prod&scoped=true&lang=css"
import style1 from "./equipment.vue?vue&type=style&index=1&id=2388ff95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388ff95",
  null
  
)

export default component.exports